angular.module('elfium').controller('companyListController', ['$scope', '$filter', 'companyService', 'elfiumToastrService', 'elfiumListFilterFactory',
    function ($scope, $filter, companyService, elfiumToastrService, elfiumListFilterFactory) {
        var that = this;
        $scope.filters = {};
        $scope.selectedSort = {};
        that.loadCompanies = function () {
            companyService.getCompanies().then(function (companies) {
                that.listFilter = new elfiumListFilterFactory($scope, companies, $scope.filters, 'companies');
            }, elfiumToastrService.error);
        };        
        $scope.openCompanyDetailModal = function (companyId) {
            companyService.openCompanyDetailModal(companyId).then(that.loadCompanies);
        };
        that.loadCompanies();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/company/companyListController.ts